<template>
    <div>
        <DefaultCard title="User Details"
                     min-height="582px"
                     :teaser="teaserText"
                     :is-busy="isBusy"
                     :error="error">
            <template #default>
                <div class="user-details" v-if="!isBusy">
                    <div class="status">
                        <label>Status</label>
                        <div v-if="user">
                            <span :class="user.activated ? 'active' : 'inactive'"></span>
                            <span>{{ user.activated ? 'Active' : 'Inactive' }}</span>
                        </div>
                    </div>
                    <template v-for="(detail, index) in userDetailsAsArray">
                        <InputField :key="index"
                                    :label="detail.key"
                                    :value="detail.value"
                                    :readOnly="true"/>
                    </template>
                    <div class="button-group" v-if="hasLoaded">
                        <TDSButton v-if="$store.getters.GET_USER_ROLE !== 'limitedSupport'" button-style="primary-red" @click="openEditModal">Edit User Information</TDSButton>
                        <TDSButton v-if="($store.getters.GET_USER_ROLE !== 'limitedSupport')/* && (user.migrationStatus !== 'COMPLETED') && (user.migrationStatus !=='NOT_APPLICABLE')*/" button-style="primary-red" @click="openMigrateModal">Migrate User</TDSButton>
                    </div>
                </div>
            </template>
        </DefaultCard>
        <DefaultCard title="Deduct Balance"
                     teaser="You can manually deduct balance here"
                     :is-busy="isBusy"
                     :error="deductError">
            <div class="deduct-group" v-if="user">
                <InputField label="Balance"
                            :read-only="true"
                            :value="deductibleBalance"/>
                <InputField label="Amount to Deduct"
                            :value.sync="dentToDeduct"
                            :validator="validateInput"
                            ref="deductDent"/>
            </div>
            <TDSButton button-style="primary-red" :show-spinner="isBusy" @click.prevent="showDeductDent" :inactive="!dentToDeduct">Deduct</TDSButton>
        </DefaultCard>
        <DefaultCard v-if="user && user.restrictions.length === 0"
                     title="Restrict user"
                     :is-busy="isBusy"
                     :error="error"
                     teaser="Block user from a certain set of features defined in a restriction. To manage restrictions and related features, please check out the restrictions page.">
            <RestrictUserForm @added="loadUser"
                              :user="user"
                              :error.sync="error"/>
        </DefaultCard>
        <DefaultCard v-else-if="user"
                     title="User is restricted!"
                     :is-busy="isBusy"
                     teaser="You can remove the users restriction here. A user can have only one restriction at a time.">

            <!-- TODO: move to separate component -->
            <InputField label="Restriction"
                        :value="user.restrictions[0].name"
                        :readOnly="true"/>
            <TDSButton v-if="$store.getters.GET_USER_ROLE !== 'limitedSupport'" button-style="primary-red"
                       type="button"
                       :show-spinner="isBusy"
                       @click.prevent="removeRestriction">
                Remove Restriction
            </TDSButton>
        </DefaultCard>

        <DefaultCard title="Restriction History"
                     :is-busy="isBusy">
            <TableList class="mb-6"
                       :columns="resrictionHistoryColumns"
                       :rows="restrictionHistory"
                       empty-text="This User has no Restriction-History">
                <template slot="column_createdAt"
                          slot-scope="{data}">
                    {{formatDate(data.createdAt)}}
                </template>
                <template slot="column_deletedAt"
                          slot-scope="{data}">
                    {{formatDate(data.deletedAt)}}
                </template>
            </TableList>
        </DefaultCard>

        <DefaultCard v-if="user"
                     :is-busy="isBusy"
                     title="Flag User"
                     teaser="You can flag a user with predefined flags. Flags have no effect on any client application and are not shown to the user.">
            <FlagUserForm :user="user"></FlagUserForm>
        </DefaultCard>
        <DefaultCard :is-busy="isBusy"
                     title="KYC Status & Information">
            <div class="kyc-info">
            <!--    Not provided a.t.m.     -->
                <!--<div>-->
                    <!--<div class="label">Timestamp</div>-->
                    <!--<div class="info">2017-12-18 10:02:34</div>-->
                <!--</div>-->
                <div>
                    <div class="label">KYC Level</div>
                    <div class="info">{{ kycInfo.level || "---" }}</div>
                </div>
                <div>
                    <div class="label">Notes</div>
                    <div class="info">{{ kycInfo.note || "---" }}</div>
                </div>
            </div>
            <TDSButton v-if="$store.getters.GET_USER_ROLE !== 'limitedSupport'" button-style="primary-red"
                       class="mt-3" type="button"
                       :show-spinner="isBusy"
                       @click.prevent="openKYCModal">
                Update KYC Level
            </TDSButton>
        </DefaultCard>
        <TDSModal v-if="showModal && showModal ==='edit'"
                  class="edit-modal"
                  @close="closeModal">
            <template v-slot:header>Edit User Information</template>
            <template v-slot:body>
                <div class="error" v-if="editError" v-html="editError" />
                <select v-model="updateType">
                    <option value="email">Email</option>
                    <option value="msisdn">MSISDN</option>
                </select>
                <InputField :value.sync="editInput"
                            :label="updateType"
                            :validator="validateInput"
                            ref="updateInput"></InputField>
                <InputField :value.sync="twoFactor"
                            :label="'2FA'"
                            :placeholder="$t('account.deletion.2FAPlaceholder')"></InputField>
            </template>
            <template v-slot:footer>
                <div style="display: flex; justify-content: space-between" class="deductButtons">
                    <TDSButton button-style="primary-red" @click="sendChanges" :inactive="!(twoFactor && editInput)" :show-spinner="isBusy">Send changes</TDSButton>
                    <TDSButton button-style="primary" @click="closeModal">Cancel</TDSButton>
                </div>
            </template>
        </TDSModal>
        <TDSModal v-if="showModal && showModal === 'deduct'"
                  class="deduct-modal"
                  @close="closeModal">
            <template v-slot:header>Deduct Balance</template>
            <template v-slot:body>
                <div class="error" v-if="deductError" v-html="deductError"/>
                <div class="deduct-group" v-if="user">
                    <InputField label="Balance"
                                :read-only="true"
                                :value="deductibleBalance"/>
                    <InputField label="Amount to Deduct"
                                :read-only="true"
                                :value.sync="dentToDeduct"/>
                </div>
                <span>Please give a reason for the deduction</span>
                <InputField label="Reason" :value.sync="deductReason"/>
            </template>
            <template v-slot:footer>
                <div style="display: flex; justify-content: space-between" class="deductButtons">
                    <TDSButton button-style="primary-red" :inactive="!deductReason" style="margin-right: 6px;" @click="deductDent">Deduct</TDSButton>
                    <TDSButton button-style="primary" @click="closeModal">Cancel</TDSButton>
                </div>
            </template>
        </TDSModal>
        <TDSModal v-if="showModal === 'migrate'" @close="closeModal">
            <template v-slot:header>Migrate User</template>
            <template v-slot:body>
                <span>Please verify the migration with your 2 Factor Authentication</span>
                <InputField label="Two Factor Authentication"
                            :value.sync="twoFactor"
                            :placeholder="$t('payments.refund.2FAPlaceholder')"/>
            </template>
            <template v-slot:footer>
                <div style="display: flex; justify-content: space-between" class="deductButtons">
                    <TDSButton button-style="primary-red" :inactive="!twoFactor" style="margin-right: 6px;" @click="migrateUser" :show-spinner="isBusy">Migrate User</TDSButton>
                    <TDSButton button-style="primary" @click="closeModal">Cancel</TDSButton>
                </div>
            </template>

        </TDSModal>
        <TDSModal v-if="showModal === 'kyc'" @close="closeModal">
            <template v-slot:header>Update KYC Level</template>
            <template v-slot:body>
                <span>Set a new KYC status. The user will be informed by a push notification about the update of their KYC request.</span>
                <SelectField label="Status"
                             :options="kycStatus"
                             name-key="name"
                             val-key="value"
                             @change="kycUpdate.level = $event"/>
                <InputField :text-field="true" label="Internal Note"
                            :value.sync="kycUpdate.note"
                            placeholder="Write something"/>
            </template>
            <template v-slot:footer>
                <div style="display: flex; justify-content: space-between" class="deductButtons">
                    <TDSButton button-style="primary-red" style="margin-right: 6px;" @click="updateKYCInfo" :show-spinner="isBusy">Set New Status</TDSButton>
                    <TDSButton button-style="primary" @click="closeModal">Cancel</TDSButton>
                </div>
            </template>

        </TDSModal>
    </div>
</template>

<script lang="ts">
import {Component, Watch} from "vue-property-decorator";
import DefaultLayout from "../layouts/DefaultLayout.vue";
import TDSError from "@/components/common/TDSError.vue";
import {DentUser} from "@/interfaces/entities/DentUser";
import TDSSpinner from "@/components/common/TDSSpinner.vue";
import {KeyValueDictionaryItem} from "@/interfaces/entities/KeyValueDictionaryItem";
import InputField from "@/components/common/InputField.vue";
import DefaultCard from "@/components/partials/DefaultCard.vue";
import {VueClassTemplate} from "@/util/VueClassTemplate";
import RestrictUserForm from "@/components/partials/Restriction/RestrictUserForm.vue";
import TDSButton from "@/components/common/TDSButton.vue";
import FlagUserForm from "@/components/partials/UserFlags/FlagUserForm.vue";
import TDSModal from "@/components/common/TDSModal/TDSModal.vue";
import regexes from "@/util/regexes";
import TableList, {TableListColumnConfig} from "@/components/common/TableList.vue";
import {GetRestrictionHistory} from "@/interfaces/httpResponses/GetRestrictionHistory";
import moment from "moment";
import {RestrictionHistoryEntry} from "@/interfaces/entities/RestrictionHistoryEntry";
import {KYCInfo} from "@/interfaces/entities/KYCInfo";
import SelectField from "@/components/common/SelectField.vue";

enum editTypes{
    email = "email",
    msisdn = "msisdn"
}

@Component({
    components: {
        SelectField,
        TableList,
        TDSModal,

    DefaultLayout, TDSError, TDSSpinner, InputField, DefaultCard, RestrictUserForm, TDSButton, FlagUserForm}
})
export default class UserSearch extends VueClassTemplate {

    private userId: string = this.$route.params.userId;
    private user: DentUser | null = null;
    private showModal: string = "";
    private editInput: string = "";
    private updateType: editTypes = editTypes.email;
    private twoFactor: string = "";
    private deductError: string = "";
    private editError: string = "";
    private dentToDeduct: number = 0;
    private deductReason: string = "";
    private modalError: string = "";
    private restrictionHistory: Array<RestrictionHistoryEntry>= [];
    private kycInfo: KYCInfo = {level: 0, note: ""};
    private kycUpdate: KYCInfo = {level: 0, note: ""};
    private kycStatus: Array<{name: string;value: number}> = [
        {name: "KYC Level 1", value: 1},
        {name: "KYC Level 2", value: 2},
        {name: "KYC Level 3", value: 3}
    ];
    private hasLoaded: boolean = false;


    @Watch("error")
    errorChanged() {
        console.log("error changed: ", this.error);
    }

    get teaserText(): string {
        return this.user ? "Details about " + this.user.firstName + " " + this.user.lastName + ": " : "";
    }

    get userDetailsAsArray(): Array<KeyValueDictionaryItem<string>> {
        if (!this.user) return [];
        return Object
            .keys(this.user)
            .filter((key: string) => !["restrictions", "whitelistings", "imageUrl", "migrationStatus"].includes(key))
            .map((key: string) => {
                return {key: key, value: (this.user as DentUser)[key as keyof DentUser] as string};
            });
    }

    get hasCreditBalance(): Boolean {
        return !!this.userDetailsAsArray.find((kv: KeyValueDictionaryItem<string>) => kv.key == "creditBalance");
    }

    get deductibleBalance(): string {
        if (this.hasCreditBalance) {
            return this.user?.creditBalance ?? "";
        }
        return this.user?.dentBalance ?? "";
    }

    showDeductDent(){
        if (!(this.$refs.deductDent as InputField).submit()) return;
        this.showModal = "deduct";
    }
    openMigrateModal(){
        this.showModal = "migrate";
    }

    async migrateUser(){
        this.startProgress("migration");
        try {
            await this.$store.dispatch("MIGRATE_USER_MANUALLY", {
                userId: this.userId,
                searchTerm: this.user?.email,
                twoFactor: this.twoFactor
            });
            this.$toastr.success("Successfully migrated user",undefined,false);
            this.showModal = "";
            this.twoFactor = "";
            await this.loadUser();
        } catch (e) {
            this.error = ("Error while migrating user: " + e.message);
            await this.$toastr.error("Error while migrating the user",undefined,false);
        }
        finally {
            this.endProgress("migration");
        }

    }


    async deductDent(){
        try {
            await this.$store.dispatch("DEDUCT_DENT", {
                userId: this.userId,
                dentToDeduct: this.dentToDeduct,
                reason: this.deductReason
            });
            this.$toastr.success("Successfully deducted " +this.dentToDeduct,undefined,false);
        } catch (e) {
            this.error = ("Error while deducting balance: " + e.message);
        }
        finally {
            this.showModal = "";
            this.loadUser();
        }

    }

    async init() {
        this.startProgress("loading");
        await this.loadUser();
        await this.loadRestrictionHistory();
        await this.loadKYCInfo();
        this.endProgress("loading");
        this.hasLoaded = true;
    }

    async loadUser() {
        try {
            const response: DentUser = await this.$store.dispatch("FETCH_USER", this.userId);
            this.user = response;
        } catch (e) {
            this.error = this.$t("general.error.loading", [e.message]) + "";
        }
    }
    async loadRestrictionHistory(){
        try {
            const response: Array<RestrictionHistoryEntry> = await this.$store.dispatch("GET_RESTRICTION_HISTORY", this.userId);
            this.restrictionHistory = response;
        } catch (e) {
            this.error = this.$t("general.error.loading", [e.message]) + "";
        }
    }
    async loadKYCInfo(){
        try {
            const response: KYCInfo = await this.$store.dispatch("GET_KYC_INFO", this.userId);
            this.kycInfo = response;
        } catch (e) {
            this.error = this.$t("general.error.loading", [e.message]) + "";
        }
    }
    openKYCModal(){
        this.kycUpdate = JSON.parse(JSON.stringify(this.kycInfo));
        this.showModal = "kyc";
    }
    async updateKYCInfo() {
        console.log("kycUpdate", this.kycUpdate);
        try {
            const response: KYCInfo = await this.$store.dispatch("UPDATE_KYC_INFO", {userId: this.userId, payload: this.kycUpdate});
            console.log("response", response);
            this.closeModal();
            this.loadKYCInfo();
            // this.kycInfo = response;
        } catch (e) {
            this.error = this.$t("general.error.loading", [e.message]) + "";
        }
    }

    async removeRestriction() {
        this.startProgress("removing_restriction");
        try {
            await this.$store.dispatch("DELETE_USERS_RESTRICTION", {
                userId: (this.user as DentUser).id,
                restrictionId: (this.user as DentUser).restrictions[0].id
            });
            await this.loadUser();
        } catch (e) {
            this.error = "<b>Couldn't remove restriction from user:</b><br>" + e.message;
        }
        this.endProgress("removing_restriction");
    }
    openEditModal(){this.showModal = "edit"}
    closeModal(){this.showModal = ""}

    async sendChanges(){
        if(!(this.$refs.updateInput as InputField).submit()){
            return;
        }
        this.startProgress("sendChanges");
        try {
            await this.$store.dispatch("EDIT_USERINFORMATION", {userId: this.userId, twoFactor: this.twoFactor, payload:{updateType: this.updateType, value: this.editInput }});
            await this.$toastr.success("Successfully changed the " + this.updateType + " to " + this.editInput, undefined, false);
        }
        catch (e) {
            this.$toastr.error("Error while updating user information.", 5000, true);
        }
        finally {
            this.endProgress("sendChanges");
        }
        await this.loadUser();
        this.showModal = "";

    }

    get resrictionHistoryColumns(): TableListColumnConfig{
        return {
            restriction: {label: "Restriction", sortable: true, width:"110px"},
            note: {label: "Note", sortable: false},
            createdAt: {label: "Created At", sortable: true, width:"130px"},
            deletedAt: {label: "Deleted At", sortable: true, width:"130px"},
            reason: {label: "Reason", sortable: false, width:"110px"}
        };
    }
    formatDate(date: string){
        let parsedDate: number = 0;
        if(!date) return "";
        if(typeof date === "string") {
            if(date.includes("[UTC]")) date = date.replace("[UTC]", "");
            parsedDate = Date.parse(date);
        }
        return (moment(parsedDate)).format("YYYY-MM-DD HH:mm");
    }

    private validateInput(): boolean {
        let isValid = true;
        this.editError = "";
        this.deductError = "";

        // If the input type is email or phone number and we are looking for
        // an exact match, we check if the input value is valid
        // else we can search for any value entered
        if(this.updateType === "msisdn") {
            isValid = regexes.phoneNumberRegex.test(this.editInput);
            if(!isValid) this.editError= this.$t("general.error.invalidPhoneNumber") + "";
        }
        if(this.updateType === "email"){
            isValid = regexes.emailRegex.test(this.editInput);
            if(!isValid) this.editError= this.$t("general.error.invalidEmail") + "";
        }


        if(this.dentToDeduct){
            isValid = regexes.intRegex.test(String(this.dentToDeduct));
            if (!isValid) this.deductError = "The given input is not Valid";
            if (this.dentToDeduct>parseInt(this.deductibleBalance)){
                isValid = false;
                this.deductError = "The value to deduct is greater than the users current Dent Balance";
            }
        }
        return isValid;
    }
}
</script>

<style lang="scss" scoped>
.deduct-group{
    display: flex;
    *{
        margin-right: 16px;
    }
}
.button-group{
    display: flex;
    flex-wrap: wrap;
    ::v-deep button {
        margin-right: 16px;
    }
    @media only screen and (max-width: $breakPoint){
        :first-child{
            margin-bottom: 8px;
        }
    }
}

.deductButtons{
    @media only screen and (max-width: $breakPoint){
        ::v-deep button{
            min-width: 100px;
        }
    }
}

.user-details {

    @media only screen and (min-width: $breakPoint) {

        margin: 0 -16px 0 0;

        ::v-deep .input-group {
            width: calc(50% - 16px);
            margin-right: 16px;
            display: inline-block;
        }
    }
}

.status{
    display: flex;
    flex-direction: column;

    label{
        color: #909090;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: .81px;
        text-transform: uppercase;
        line-height: 12px;
        display: block;
        margin-bottom: 4px;
    }
    span{
        font-size: 12px;
        line-height: 1;
    }
    div{
        display: flex;
    }

    .inactive {
        background: transparent url('../../assets/icons/close-circle-dent-red.svg') no-repeat center;
        background-size: 12px auto;
        height: 12px;
        width: 12px;
        display: block;
        margin-right: 4px;
    }
    .active {
        background: transparent url('../../assets/icons/check-circle-green.svg') no-repeat center;
        height: 12px;
        width: 12px;
        background-size: 12px;
        display: block;
        margin-right: 4px;

    }
}

.kyc-info {
    display: flex;
    justify-content: stretch;

    > div {
        flex: 1;

        .label {
            @include fontCaption();
        }
    }
}

</style>
